module.exports = __webpack_public_path__ + "static/kid1-14194886a1d9e599ba0f9234d4efe955.jpg";